import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import male from '../../../src/images/male.png';
import female from '../../../src/images/female.png';
import {FaFacebookF,FaYoutube,FaInstagram} from "react-icons/fa";

 

 
 

import { Container, Jumbotron, TabContainer,Row,Col,Card,Button, } from 'react-bootstrap';
import './TeamDetail.css';
import { Link } from 'react-router-dom';
 

const TeamDetail = () => {
   
    const {teamId} =  useParams();
   const[teams,setTeam]= useState({});
   const {strTeamBadge,idTeam,strKeywords,strTeam,intFormedYear,strCountry,strSport,strGender,strDescriptionEN,strTeamFanart3,strTeamFanart2,strYoutube,strInstagram,strFacebook} = teams
    useEffect(() => {},[])
    fetch(`https://www.thesportsdb.com/api/v1/json/1/lookupteam.php?id=${teamId}`) 
 
  .then(res => res.json())
  .then(data => setTeam(data.teams[0]));
    return ( 
        <Container className=' col-sm-12 col-md-12 my-3 detail' >
            <Card.Img className=' col-sm-12 col-md-12' variant="top" src= {strTeamBadge} style={{height:'100px',width:'120px',position:'absolute',transform:'translate(-50%,-150%)',top:'-10%',left:'50%'}}/>
            <Row>
    <Col className='detail' sm={8}   > <h1  className='col-xs-12 col-md-12 col-sm-12' style={{color:'white'}}> {strTeam} </h1>
    <p  className='col-xs-12 col-md-12 col-sm-12' >Founded : {intFormedYear}</p>
    <p className='col-xs-12 col-md-12 col-sm-12'  >Country:{strCountry}</p> 
    <p  className='col-xs-12 col-md-12 col-sm-12'  >Sports Type: {strSport}</p>
    <p  className='col-xs-12 col-md-12 col-sm-12'  >Gender: {strGender}</p>
    </Col>
   
    
    <Col className='detail' sm={4}   > 
 
    
    
    {
      strGender &&
        (strGender === 'Male' ? (
          <img src={male}/>
        ) : (
          <img src={female}/>
        ))}
      


</Col>

    
  
  
  </Row>
   
  <Card>
  <Card.Body> <p  className='col-xs-12 col-md-12 col-sm-12 description'  >{strDescriptionEN}</p>    </Card.Body>
  <Card.Body   className='col-xs-12 col-md-12 col-sm-12 icon'  >   <a href={`https://${strFacebook}`}> <FaFacebookF></FaFacebookF></a> <a href={`https://${strInstagram}`}> <FaInstagram></FaInstagram>  </a> <a href={`https://${strYoutube}`}> <FaYoutube></FaYoutube> </a>    </Card.Body>
 
   
</Card>
      
  

</Container>
 

 
      
    );
};

export default TeamDetail;